module.exports = __webpack_public_path__ + "media/images/flags/tg-e6cb3a2c375fc72a205b14a22130fb4d.svg";